import { LoanHeader } from './LoanHeader';

export default LoanHeader;
